import React from "react";
import { Chip, Box, useTheme } from "@mui/material";

interface CellChipArrayProps {
  children: any;
}

const CellChipArray: React.FC<CellChipArrayProps> = ({ children }) => {
  const theme = useTheme();
  // Convert children to array if it's not already
  const arrayData = Array.isArray(children) ? children : [children];
  
  // Filter out null, undefined, or empty values
  const validData = arrayData.filter(item => 
    item !== null && 
    item !== undefined && 
    item !== '' && 
    String(item).trim() !== ''
  );

  // If no valid data, return empty
  if (validData.length === 0) {
    return null;
  }

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: 0.5,
        maxWidth: '100%',
        overflow: 'hidden'
      }}
    >
      {validData.map((item, index) => (
        <Chip
          key={index}
          label={String(item)}
          size="small"
          variant="outlined"
          color="primary"
          sx={{
            fontSize: '0.7rem',
            height: '20px',
            maxWidth: '150px',
            '& .MuiChip-label': {
              padding: '0 6px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
            '& .MuiChip-outlined': {
              borderColor: theme.palette.warning.main,
              color: theme.palette.warning.main,
            },
            '&:hover': {
              backgroundColor: theme.palette.mode === 'dark' 
                ? theme.palette.warning.dark + '40' 
                : theme.palette.warning.light + '80',
            },
          }}
        />
      ))}
    </Box>
  );
};

export default CellChipArray;
